module.exports = __webpack_public_path__ + "static/media/book-reader.e1f51685.svg";